export default {
  CASH_REGISTER_READINGS_LIST: "Liste des lectures de caisse",
  ADD_CASH_REGISTER_READING: "Ajouter une lecture de caisse",
  CASH_REGISTER_READING_ADDED: "Lecture de caisse ajoutée",
  EDIT_CASH_REGISTER_READING: "Modifier la lecture de caisse",
  CASH_REGISTER_READING_UPDATED: "Lecture de caisse mise à jour",
  DELETE_THIS_CASH_REGISTER_READING: "Supprimer cette lecture de caisse ?",
  CASH_REGISTER_READING_DELETED: "Lecture de caisse supprimée",
  STARTS_AT: "Début",
  ENDS_AT: "Fin",
  CREATED_BY: "Créé par",
  UPDATED_BY: "Modifié par",
  TOTAL_AMOUNT: "Montant total",
  TITLE: "Titre",
  CASH_REGISTER_CATEGORY_PEDAGO: "Pédagogie",
  EVENT_CATEGORY_THEMATIC_MEAL: "Repas Thématique",
  EVENT_CATEGORY_TASTING: "Dégustation",
  EVENT_CATEGORY_PROMOTION: "Promotion",
  EVENT_CATEGORY_EVENT: "Événement",
  EVENT_CATEGORY_INTERNAL_JOURNAL: "Journal Interne",
  EVENT_CATEGORY_CLIENT_JOURNAL: "Journal Client",
  EVENT_CATEGORY_SURVEY: "Sondage",
  EVENT_CATEGORY_MONTHLY_INSPIRATION: "Inspiration du Mois",
  EVENT_CATEGORY_OPEN_HOUSE: "Porte-Ouverte",
  SHOW_MY_EVENTS: "Voir les caisses qui me concernent",
  SHOW_CASH_REGISTER: "Voir la caisse",
  SHOW_ALL: "Voir toutes les caisses",
  EXPENSE_LINE: "Ligne dépense",
  TOTAL_EXPENSES: "Total des dépenses",
  TOTAL_SALES: "Total des ventes",
  CASH_BALANCE: "Ventes nettes",
  CASH: "Interac débit du terminal",
  MASTERCARD_CARD: "Carte de crédit MasterCard",
  VISA_CARD: "Carte de crédit Visa",
  DEBIT_CARD: "Carte de débit du terminal",
  PREPAIED_CARD: "Achat avec carte Laniel",
  OTHER: "Autre",
  TOTAL_CASHOUT: "Total Cashout",
  CANCEL_CASH_REGISTER_READING_QUESTION: "Annuler la lecture de caisse ?",
  VALIDATE_CASH_REGISTER_READING_QUESTION: "Valider la lecture de caisse ?",
  STATUS_DRAFT: "Brouillon",
  STATUS_CANCELED: "Annulée",
  STATUS_VALIDATED: "Validée",
  REGISTER_ERRORS: "Erreur de poinçon",
  CASHIN: "Lecture de caisse (Z ou Net1 ou vente brute)",
  CASHOUT: "Facture payée (achat extérieur)",
  NUMBER_Z: "Numéro Z",
  COINS: "Monnaie",
  AMOUNT_ACCOUNT: "Argent comptant",
  TOTAL_AMOUNT_ACCOUNT: "Total Argent comptant",
  TOTAL_PAYMENT_METHODS: "Total mode de paiement",
  PAYMENT_METHODS: "Mode de paiement",
  SUBMITION: "Soumissions",
  EXPECTED_ACCOUNT: "COMPTE À RECEVOIR",
  AMOUNT_GAP: "Écart avec le total des ventes",
  TOTAL_OF_SALES: "Total des ventes",
  TRANSACTION_COUNT: "Nombre de Transaction",
  GAPS_WHEN_VALIDATE: "Il y a un écart de {gap} avec le total des ventes, voulez-vous valider la lecture de caisse ?",
  GAPS_WHEN_CANCEL: "Il y a un écart de {gap} avec le total des ventes, voulez-vous annuler la lecture de caisse ?",
  CHECKOUT_PERSON: "Caissière",
  CASH_REGISTERS_CHECK: "Lectures de caisses",
  CASH_REGISTERS_NEED_READING: "Certaines caisses n'ont pas de lecture aujourd'hui",
  CREATE_READING: "Créer une lecture",
  ALL_CASH_REGISTERS_CHECKED: "Toutes les caisses ont été vérifiées aujourd'hui",
  AUTO_CREATED_READING: "Lecture créée automatiquement depuis le tableau de bord",
  READING_CREATED_SUCCESSFULLY: "Lecture de caisse créée avec succès",
  GAP_NOTE_LABEL: "Note",
  GAP_NOTE_PLACEHOLDER: "Note",
  GAP_NOTE_REQUIRED_HINT: "Veuillez renseigner la justification de l'écart",
  GAP_NOTE_REQUIRED_MESSAGE: "Veuillez renseigner la justification de l'écart avant de valider.",
  RECORD_SALES_WIDGET_TITLE: "Records de ventes",
  RECORD_SALES_VIEW_ALL: "Voir tout le classement",
  RECORD_SALES_MODAL_TITLE: "Classement des records de toutes les écoles",
  RECORD_SALES_NO_DATA: "Aucune lecture validée pour l'instant",
  RECORD_SALES_NO_SALES_PERIOD: "Aucune vente validée sur cette période",
  RECORD_SALES_SINCE: "il y a {duration}",
  RECORD_SALES_TODAY: "aujourd'hui",
  RECORD_SALES_YEARS: "{count} an | {count} ans",
  RECORD_SALES_MONTHS: "{count} mois | {count} mois",
  RECORD_SALES_DAYS: "{count} jour | {count} jours",
  RECORD_SALES_AND: "et",
  RECORD_SALES_PERIOD_MONTH: "Record du mois",
  RECORD_SALES_PERIOD_MONTH_OF: "Record de {month}",
  RECORD_SALES_PERIOD_MONTH_OF_VOWEL: "Record d'{month}",
  RECORD_SALES_PERIOD_SCHOOL_YEAR: "Record de l'année scolaire",
  RECORD_SALES_PERIOD_ALL_TIME: "Record absolu",
  RECORD_SALES_NEW_RECORD: "Nouveau record !",
  RECORD_SALES_NEW_FIRST_PLACE: "Nouvelle 1re place !",
  RECORD_SALES_FIRST_TOOLTIP_TITLE_MONTH: "Nouvelle 1re place du mois !",
  RECORD_SALES_FIRST_TOOLTIP_TITLE_SCHOOL_YEAR: "Nouvelle 1re place de l'année scolaire !",
  RECORD_SALES_FIRST_TOOLTIP_TITLE_ALL_TIME: "Nouvelle 1re place au classement absolu !",
  RECORD_SALES_FIRST_TOOLTIP_TOOK: "Votre école a pris la tête du classement le {date}. Ancienne 1re place : {school} ({amount}).",
  RECORD_SALES_CHEER_TOOK_FIRST: "Vous venez de prendre la 1re place, bravo ! Juste derrière vous : {school}.",
  RECORD_SALES_CELEBRATION_TOOK_FIRST: "Vous avez pris la 1re place du classement ! Ancienne 1re place : {school} ({amount}).",
  RECORD_SALES_TOOLTIP_TITLE_MONTH: "Nouveau record du mois !",
  RECORD_SALES_TOOLTIP_TITLE_SCHOOL_YEAR: "Nouveau record de l'année scolaire !",
  RECORD_SALES_TOOLTIP_TITLE_ALL_TIME: "Nouveau record absolu !",
  RECORD_SALES_TOOLTIP_WHAT_MONTH: "Le record du mois est la meilleure journée de ventes de votre école depuis le 1er {month}.",
  RECORD_SALES_TOOLTIP_WHAT_SCHOOL_YEAR: "Le record de l'année scolaire est la meilleure journée de ventes de votre école depuis le 1er août {year}.",
  RECORD_SALES_TOOLTIP_WHAT_ALL_TIME: "Le record absolu est la meilleure journée de ventes de votre école, toutes années confondues.",
  RECORD_SALES_TOOLTIP_BEATEN: "Votre école l'a battu le {date} avec {amount} ; l'ancien record était de {previous} ({previousDate}).",
  RECORD_SALES_TOOLTIP_DURATION: "Ce badge reste affiché {days} jours après le record.",
  RECORD_SALES_TOOLTIP_CLICK: "Cliquez sur le badge pour célébrer !",
  RECORD_SALES_CELEBRATION_TITLE: "Félicitations !",
  RECORD_SALES_CELEBRATION_BEATEN: "Vous avez battu votre dernier record du {date} de {amount} !",
  RECORD_SALES_CELEBRATION_NEW: "Votre nouveau record",
  RECORD_SALES_CELEBRATION_MSG_TEAM: "Toute l'équipe peut être fière de ce résultat.",
  RECORD_SALES_CELEBRATION_MSG_WORK: "C'est le fruit de votre travail au quotidien : merci et bravo !",
  RECORD_SALES_CELEBRATION_MSG_FIRST: "Et votre école occupe la 1re place sur {count} écoles !",
  RECORD_SALES_CELEBRATION_MSG_NEXT: "Continuez sur cette lancée, le prochain record n'est pas loin !",
  RECORD_SALES_CELEBRATION_CLOSE: "Merci !",
  RECORD_SALES_DESC_MONTH: "Meilleure journée de ventes de votre école depuis le 1er {month}.",
  RECORD_SALES_DESC_SCHOOL_YEAR: "Meilleure journée de ventes depuis le début de l'année scolaire, le 1er août {year}.",
  RECORD_SALES_DESC_ALL_TIME: "Meilleure journée de ventes de votre école, toutes années confondues.",
  RECORD_SALES_CHEER_NEW_AND_FIRST: "Nouveau record et 1re place : bravo à toute l'équipe !",
  RECORD_SALES_CHEER_NEW_MONTH: "Bravo, nouveau record du mois ! Toute l'équipe peut être fière.",
  RECORD_SALES_CHEER_NEW_SCHOOL_YEAR: "Bravo, nouveau record de l'année scolaire ! Continuez sur cette lancée.",
  RECORD_SALES_CHEER_NEW_ALL_TIME: "Record absolu battu : du jamais vu pour votre école, félicitations !",
  RECORD_SALES_CHEER_FIRST: "Félicitations, votre école occupe la 1re place ! Gardez le cap.",
  RECORD_SALES_CHEER_LAST_DAY_TOP_MONTH: "Belle lancée : votre dernière journée est la {rank} meilleure du mois !",
  RECORD_SALES_CHEER_LAST_DAY_TOP_SCHOOL_YEAR: "Belle lancée : votre dernière journée est la {rank} meilleure de l'année scolaire !",
  RECORD_SALES_CHEER_LAST_DAY_TOP_ALL_TIME: "Belle lancée : votre dernière journée est la {rank} meilleure de l'histoire de votre école !",
  RECORD_SALES_CHEER_GAP: "Plus que {gap} pour prendre la {rank} place ! Juste devant : {school}.",
  RECORD_SALES_SCHOOL_RANK: "{rank} sur {count} écoles",
  RECORD_SALES_RANK_OUT_OF: "sur {count} écoles",
  RECORD_SALES_LAST_DAY: "Dernière journée",
  RECORD_SALES_LAST_DAY_RANK: "Dernière journée : {rank} sur {count}",
  RECORD_SALES_BEST_DAYS: "Mes meilleures journées",
  RECORD_SALES_RANKING: "Classement des écoles",
  RECORD_SALES_MY_SCHOOL: "Mon école",
  RECORD_SALES_ORDINAL_FIRST: "1re",
  RECORD_SALES_ORDINAL: "{rank}e",
  SALE_AMOUNT: "Montant de la vente",
  COUPON_TO_INVOICE: "Coupon (À facturer)",
  ACTUAL_RECEIVED_AMOUNT: "Montant réellement reçu",
  ACTUAL_RECEIVED_AMOUNT_HINT: "Total encaisse moins les coupons à facturer",
  REGISTER_DATA_TITLE: "Données de la caisse",
  REGISTER_PREVIEW_LOADING: "Recherche des ventes enregistrées par la caisse…",
  REGISTER_PREVIEW_FOUND:
    "Ventes trouvées dans la caisse : Z de {z}, {count} transactions, dernière vente à {time}.",
  REGISTER_PREVIEW_AUTOFILL_HINT:
    "Les montants seront remplis automatiquement à l'enregistrement. Il restera à compter le tiroir.",
  REGISTER_PREVIEW_NO_SALES:
    "Aucune vente dans la caisse pour cette journée : la lecture sera à remplir à la main.",
  REGISTER_PREFILL_BUTTON: "Remplir depuis la caisse",
  REGISTER_REFRESH_BUTTON: "Actualiser depuis la caisse",
  REGISTER_PREFILL_CONFIRM_TITLE: "Remplir la lecture depuis la caisse ?",
  REGISTER_PREFILL_CONFIRM_CHANGES: "Ces champs vont changer :",
  REGISTER_PREFILL_NO_CHANGES: "La lecture correspond déjà à la caisse.",
  REGISTER_PREFILL_MANUAL_FIELDS_KEPT:
    "Le comptage du tiroir, la caissière, les erreurs de poinçon, les dépenses et la note ne sont pas modifiés.",
  REGISTER_PREFILL_DONE: "Lecture remplie depuis la caisse",
  REGISTER_PREFILL_FAILED_AFTER_CREATE:
    "Lecture créée, mais les montants n'ont pas pu être lus dans la caisse : {reason}",
  REGISTER_NO_SALES_FOR_READING:
    "Aucune vente dans la caisse pour la journée de cette lecture.",
  REGISTER_PREFILLED_AT: "Rempli depuis la caisse le {date}.",
  REGISTER_LAST_SALE: "Dernière vente enregistrée : {time}.",
  REGISTER_EXPECTED_CASH: "Comptant attendu selon la caisse",
  REGISTER_COUNTED_CASH: "Comptant compté",
  REGISTER_CASH_GAP: "Écart",
  REGISTER_RELOADS_EXCLUDED: "Rechargements de cartes exclus du Z : {amount}",
  REGISTER_UNMAPPED_PAYMENTS:
    "Modes de paiement sans champ dans la lecture, à reporter dans le bon champ :",
  REGISTER_INCOHERENT:
    "Dans la caisse, le total des ventes ({z}) ne correspond pas à la somme des paiements ({payments}). Vérifiez le rapport Z.",
  REGISTER_FIELD_BADGE: "Caisse",
  REGISTER_FIELD_BADGE_TOOLTIP: "Valeur lue dans la caisse",
  REGISTER_ERROR_CASH_REGISTER_NOT_LINKED_TO_ISTHERA:
    "Cette caisse n'est pas reliée au logiciel de caisse.",
  REGISTER_ERROR_CASH_REGISTER_READING_NOT_DRAFT:
    "Seule une lecture en brouillon peut être remplie depuis la caisse.",
  REGISTER_ERROR_ISTHERA_UNAVAILABLE:
    "Le logiciel de caisse ne répond pas. Réessayez dans quelques minutes ou remplissez la lecture à la main.",
  REGISTER_NUMBER_Z_CHECK:
    "Selon la caisse, le numéro Z de cette journée est {expected} (saisi : {typed}). Vérifiez le rapport Z.",
  REGISTER_BASIS_DAY:
    "Aucun rapport Z daté de ce jour dans la caisse : les montants sont ceux des ventes de la journée.",
  REGISTER_PARTIAL_PREFILL:
    "Remplissage partiel : seuls le numéro Z, le total du Z et le nombre de transactions viennent de la caisse. Les paiements se saisissent à la main.",
  REGISTER_PREVIEW_PARTIAL_AUTOFILL_HINT:
    "Le numéro Z, le total du Z et le nombre de transactions seront remplis à l'enregistrement. Il restera à saisir les paiements et à compter le tiroir.",
  REGISTER_SUMMARY_TITLE: "Ce qui vient de la caisse",
  REGISTER_SUMMARY_NOT_PREFILLED: "Cette lecture n'a pas été remplie depuis la caisse.",
  REGISTER_SUMMARY_MODE_FULL: "Remplissage complet.",
  REGISTER_SUMMARY_MODE_PARTIAL: "Remplissage partiel : numéro Z, total du Z et transactions.",
  REGISTER_SUMMARY_ALL_SAME: "Toutes les valeurs sont celles de la caisse.",
  REGISTER_SUMMARY_CHANGED_COUNT:
    "{count} valeur modifiée à la main depuis le remplissage | {count} valeurs modifiées à la main depuis le remplissage",
  REGISTER_SUMMARY_FIELD: "Champ",
  REGISTER_SUMMARY_REGISTER_VALUE: "Selon la caisse",
  REGISTER_SUMMARY_READING_VALUE: "Dans la lecture",
  REGISTER_SUMMARY_CHANGED: "Modifié",
};
